
import service from '@/store/services/settings/client-service';

const state = {
    list: {},
    client: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, client) => {
        state.client = client;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(client => {
                commit('SET_RESOURCE', client);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(client => {
                commit('SET_RESOURCE', client);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((client) => {
                commit('SET_RESOURCE', client);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((client) => {
                commit('SET_RESOURCE', client);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    client: state => state.client,
    dropdown: (state) => {
        return state.list.map(client => ({
            id: client.id,
            name:client.name,
            redirect:client.redirect,
            secret:client.secret,
            revoked:client.revoked
        }));
    }
};

const clients = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default clients;
